var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustryImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 2.84375C10.4349 2.84375 9.34375 3.93494 9.34375 5.28125H6.09375C4.74744 5.28125 3.65625 6.37244 3.65625 7.71875V18.2812C3.65625 19.6276 4.74744 20.7188 6.09375 20.7188H19.9062C21.2526 20.7188 22.3438 19.6276 22.3438 18.2812V7.71875C22.3438 6.37244 21.2526 5.28125 19.9062 5.28125H16.6562C16.6562 3.93494 15.5651 2.84375 14.2188 2.84375H11.7812ZM11.7812 4.46875H14.2188C14.6672 4.46875 15.0312 4.83234 15.0312 5.28125H10.9688C10.9688 4.83234 11.3327 4.46875 11.7812 4.46875ZM6.09375 6.90625H19.9062C20.3552 6.90625 20.7188 7.26984 20.7188 7.71875V11.1021C19.4432 11.3203 16.3625 11.7812 13 11.7812C9.63857 11.7812 6.55772 11.3206 5.28125 11.1021V7.71875C5.28125 7.26984 5.64484 6.90625 6.09375 6.90625ZM5.28125 12.7501C6.43968 12.9414 8.52889 13.2333 10.9688 13.3515V13.4062C10.9688 13.8552 11.3323 14.2188 11.7812 14.2188H13.8125C14.2614 14.2188 14.625 13.8552 14.625 13.4062V13.3729C17.2405 13.2704 19.4955 12.952 20.7188 12.7501V18.2812C20.7188 18.7302 20.3552 19.0938 19.9062 19.0938H6.09375C5.64484 19.0938 5.28125 18.7302 5.28125 18.2812V12.7501Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryImg);
export default __webpack_public_path__ + "static/media/industryImg.1639baacc75879c39c31352bae3457f8.svg";
export { ForwardRef as ReactComponent };